import * as React from 'react';
import { FC } from 'react';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import { t } from 'state/intl/translations';

import { IDonationsModalProps } from './types';

/**
 *
 * DonationsModal purpose: to display a modal with
 * more information regarding Donations.
 *
 */
const DonationsModal: FC<React.PropsWithChildren<IDonationsModalProps>> = ({
  isOpen,
  onCloseCallback,
  title,
  modalAppearanceEventMessage,
  children,
  testID,
  buttonText,
}) => {
  return (
    <Dialog
      showDialog={isOpen}
      testID={testID}
      heading={title}
      bodyComponent={children}
      actions={
        <ActionButton fullWidth onPress={onCloseCallback} mt={4}>
          {buttonText ?? t('okayButtonText')}
        </ActionButton>
      }
      modalAppearanceEventMessage={modalAppearanceEventMessage}
      onDismiss={onCloseCallback}
    />
  );
};

export default DonationsModal;
